import React from 'react';
import { MapPin, Phone, Mail, Clock, PhoneCall, MapIcon } from 'lucide-react';
import useResponsive from '../hooks/useResponsive';

const INFO = [
  { icon: MapPin,   label:'Address',       val:'454/20 (old no. 348/18) , Subhash Nagar Colony, Hansi - 125033 , Haryana', color:'#f97316' },
  { icon: Phone,    label:'Phone',         val:'+91 7206123646', color:'#60a5fa' },
  { icon: Mail,     label:'Email',         val:'contact@trinityglobalofficial.com', color:'#c084fc' },
  { icon: Clock,    label:'Working Hours', val:'Mon – Sat: 9:00 AM – 8:00 PM', color:'#4ade80' },
];

export default function Contact() {
  const { isMobile, isTablet } = useResponsive();
  const paddingH = isMobile ? 16 : isTablet ? 24 : 40;

  return (
    <div style={{ padding: `80px ${paddingH}px`, minHeight:'100vh', paddingTop:'80px' }}>
      <div style={{
        display:'grid',
        gridTemplateColumns: isMobile ? '1fr' : isTablet ? '1fr' : '1fr 1.2fr',
        gap: isMobile ? 36 : isTablet ? 40 : 50,
        alignItems:'start', maxWidth:1200, margin:'0 auto'
      }}>

        {/* ── Left Column ── */}
        <div>

          {/* Badge */}
          <div style={{ display:'inline-flex', alignItems:'center', gap:7, padding:'6px 16px', borderRadius:99, background:'rgba(255,255,255,0.04)', border:'1px solid rgba(255,255,255,0.07)', fontSize:12, fontWeight:600, color:'#4ade80', marginBottom:18 }}>
            <PhoneCall size={13} strokeWidth={2.5} />
            Get In Touch
          </div>

          {/* Heading */}
          <h2 style={{ fontFamily:"'Outfit',sans-serif", fontSize: isMobile?28:isTablet?34:40, fontWeight:800, color:'#fff', letterSpacing:-1, marginBottom:16, lineHeight:1.2 }}>
            Apna Career<br />
            <span style={{ background:'linear-gradient(135deg,#38bdf8,#f97316,#c084fc)', backgroundSize:'300%', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent', backgroundClip:'text', animation:'gx 5s ease infinite' }}>Aaj Hi</span><br />
            Shuru Karo
          </h2>

          <p style={{ fontFamily:"'DM Sans',sans-serif", fontSize:14, color:'#64748b', lineHeight:1.85, marginBottom:28 }}>
            Free counselling session ke liye aaj hi contact karo. Hamare experts tumhare liye best course recommend karenge.
          </p>

          {/* Info Cards */}
          <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
            {INFO.map(({ icon: Icon, label, val, color }) => (
              <div key={label} style={{ display:'flex', alignItems:'center', gap:14, borderRadius:14, padding:'14px 16px', background:'rgba(255,255,255,0.04)', backdropFilter:'blur(14px)', border:'1px solid rgba(255,255,255,0.07)' }}>
                
                <div style={{ width:36, height:36, borderRadius:10, display:'flex', alignItems:'center', justifyContent:'center', background:`${color}18`, border:`1px solid ${color}30`, flexShrink:0 }}>
                  <Icon size={17} color={color} strokeWidth={2} />
                </div>

                <div>
                  <div style={{ fontFamily:"'DM Sans',sans-serif", fontSize:11, color:'#475569', fontWeight:600, textTransform:'uppercase', letterSpacing:0.5, marginBottom:2 }}>
                    {label}
                  </div>

                  <div style={{ fontFamily:"'DM Sans',sans-serif", fontSize: isMobile?12:13, fontWeight:500 }}>
                    
                    {/* 👇 Clickable Logic */}
                    {label === "Email" ? (
                      <a href={`mailto:${val}`} style={{ color:'#e2e8f0', textDecoration:'none' }}>
                        {val}
                      </a>
                    ) : label === "Phone" ? (
                      <a href={`tel:${val}`} style={{ color:'#e2e8f0', textDecoration:'none' }}>
                        {val}
                      </a>
                    ) : (
                      <span style={{ color:'#e2e8f0' }}>{val}</span>
                    )}

                  </div>
                </div>

              </div>
            ))}
          </div>
        </div>

        {/* ── Right Column: Map ── */}
        <div style={{ borderRadius:24, overflow:'hidden', border:'1px solid rgba(255,255,255,0.07)', boxShadow:'0 4px 32px rgba(0,0,0,0.4)', display:'flex', flexDirection:'column' }}>
          
          {/* Map Header */}
          <div style={{ padding:'12px 18px', background:'rgba(255,255,255,0.04)', borderBottom:'1px solid rgba(255,255,255,0.06)', display:'flex', alignItems:'center', gap:8 }}>
            <MapPin size={15} color="#f97316" strokeWidth={2} />
            <span style={{ fontFamily:"'DM Sans',sans-serif", fontSize:13, color:'#94a3b8', fontWeight:500 }}>
              Subhash Nagar Colony, Hansi, Haryana
            </span>

            <a
              href="https://www.google.com/maps/search/Subhash+Nagar+Colony+Hansi+Haryana+125033"
              target="_blank"
              rel="noopener noreferrer"
              style={{ marginLeft:'auto', fontSize:12, color:'#f97316', textDecoration:'none', fontFamily:"'DM Sans',sans-serif", fontWeight:600, display:'flex', alignItems:'center', gap:4 }}
            >
              <MapIcon size={13} strokeWidth={2} />
              Open in Maps
            </a>
          </div>

          {/* Map */}
          <iframe
            title="Trinity Global Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3483.0!2d75.9715!3d29.1040!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391232b0b0b0b0b0%3A0x0!2sSubhash+Nagar+Colony%2C+Hansi%2C+Haryana+125033!5e0!3m2!1sen!2sin!4v1690000000000!5m2!1sen!2sin"
            width="100%"
            height={isMobile ? 320 : isTablet ? 420 : 520}
            style={{ display:'block', border:'none', filter:'invert(90%) hue-rotate(180deg)' }}
            loading="lazy"
          />
        </div>

      </div>
    </div>
  );
}